import { Core } from "@faire/design-tokens";
import { isAndroid, isIOS } from "@faire/help-center-utils/lib/isMobileApp";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

import {
  isAndroidChatEnabled,
  isIOsChatEnabled,
} from "../../utils/isMobileChatEnabled";

export const LiveChatUnavailable: React.FC = () => {
  if (
    (isIOS() && !isIOsChatEnabled()) ||
    (isAndroid() && !isAndroidChatEnabled())
  ) {
    return (
      <>
        <Spacer width="2x" />
        <Typography variant="labelSansRegular" color={Core.text.subdued}>
          <StrictLocalMsg defaultMessage="Live chat is currently available in English on desktop." />
        </Typography>
      </>
    );
  }
  return null;
};
